import { render, staticRenderFns } from "./PrinterCard.vue?vue&type=template&id=26c4b68e&"
import script from "./PrinterCard.vue?vue&type=script&lang=js&"
export * from "./PrinterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports